<template>
  <div>
    <span @click="toggle_reject_modal()" class="px-3 py-2 mr-2 rounded is-clickable" style="box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; background: rgb(255, 255, 255)">
      <i class="text-red-500 fa-solid fa-ban"></i>
    </span>
    <!-- BLOCK: Product service modal -->
    <div class="fixed top-0 left-0 flex items-start justify-center w-screen h-screen bg-black bg-opacity-50" v-if="show_reject_modal" @click.self="toggle_reject_modal()">
      <div class="flex-col p-0 mt-20 bg-white products-search">
        <div class="p-2 text-center bg-slate-100">Refuzo shitjen</div>
        <div class="flex flex-col p-2 text-14px">
          <div class="flex flex-col mx-5 mb-2">
            <span> Arsyet </span>
            <select v-model="reject_info.reason" class="border rounded">
              <option v-for="(reason, index) in rejecton_reasons" :key="index" :value="reason.guid">{{ reason.text }}</option>
            </select>
          </div>
          <div class="flex flex-col mx-5">
            <span>Shenime</span>
            <textarea v-model="reject_info.text" class="px-2 border rounded" rows="4"></textarea>
          </div>
        </div>
        <div class="flex p-2 border-t">
          <a @click.prevent="save_reject()" class="w-full text-center bg-red-300 border border-red-600 rounded" href=""> Refuzo </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";
import ConfigurationService from "@/services/Configuration.js";
import { useProcessStore } from "@/stores/process";
export default {
  data() {
    return {
      rejecton_reasons: [],
      show_reject_modal: false,
      reject_info: {},
    };
  },
  methods: {
    async toggle_reject_modal() {
      this.show_reject_modal = !this.show_reject_modal;
      if (this.show_reject_modal) {
        this.rejecton_reasons = await ConfigurationService.getRejectionReasons();
      }
    },
    save_reject() {
      if (!this.reject_info.reason && !this.reject_info.reason) {
        this.$toast.error("Zgjidhni nje nga arsyet ose shkruani nje arsye tek shenimet.");
        return;
      }
      Api(true)
        .post("/processes/reject", {
          reject_info: this.reject_info,
          process: useProcessStore().process,
        })
        .then((res) => {
          if (res.data.message == 1) {
            this.$toast.success("Shitja u refuzua");
            window.location.reload();
          }
        });
    },
  },
};
</script>
<style>
.products-search {
  min-width: 80%;
  margin-left: 30px;
  margin-right: 30px;
}
</style>
